import { DescriptionPage_WeeklyMaterialItemType as WeeklyMaterialItemType } from '__generated__/graphql-types';

import type { WeeklyMaterialFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedCourseEntitiesFragments';
import getGroupedAssessments from 'bundles/unified-description-page-common/utils/getGroupedAssessments';

const getTotalQuizzesAndAssignments = (weeks: WeeklyMaterialFragment[]) => {
  const { totalQuizzes, totalAssignments, containsAiGrading } = weeks.reduce(
    (prev, week) => {
      const groupedAssessments = getGroupedAssessments(week.assessments);
      const quizzes = groupedAssessments?.[WeeklyMaterialItemType.Quiz];
      const assignments = groupedAssessments?.[WeeklyMaterialItemType.Assignment];

      const hasAiGradedAssignments = week.assessments?.some((assessment) => assessment.containsAiGrading) || false;

      return {
        totalQuizzes: quizzes?.length ? prev.totalQuizzes + quizzes.length : prev.totalQuizzes,
        totalAssignments: assignments?.length ? prev.totalAssignments + assignments.length : prev.totalAssignments,
        containsAiGrading: prev.containsAiGrading || hasAiGradedAssignments,
      };
    },
    { totalQuizzes: 0, totalAssignments: 0, containsAiGrading: false }
  );

  return { totalQuizzes, totalAssignments, containsAiGrading };
};

export default getTotalQuizzesAndAssignments;
